// VNEC v9 — pages/efficiency.js
// Iframe wrapper cho dashboard Hiệu quả Dự án (file public/efficiency-dashboard.html)
export async function renderEfficiency() {
  window.__pageInit = init;
  return `
    <div class="page" style="padding:0">
      <div class="page-header" style="padding:16px 20px 8px">
        <h1 style="font-family:Cambria,Georgia,serif">PnL Efficiency</h1>
        <p class="muted small">Upload file Excel BKSNB Hiệu quả để xem phân tích từng dự án</p>
      </div>
      <div style="padding:0 12px 12px">
        <iframe id="ef-frame" src="/efficiency-dashboard.html"
          style="width:100%;height:calc(100vh - 140px);border:1px solid #EEE;border-radius:8px;background:#f0f2f5"
          title="Efficiency Dashboard"></iframe>
      </div>
    </div>`;
}

function init() { /* iframe loads itself */ }
